var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.addressClass && _vm.addressClass.iconSource)?_c('img',{staticClass:"store-logo",attrs:{"src":_vm.addressClass.iconSource,"height":"40","contain":"","alt":`logo ${_vm.addressClass.name}`}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }